import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function toSentenceCase(value, { preserveCapitalization = false } = {}) {
  const protectedText = [];
  let text = value.trim().replace(/(?:https?:\/\/|www\.)\S+|\b[^\s@]+@[^\s@]+\.[^\s@]+/gi, (match) => {
    const content = match.replace(/[.,!?;:)]+$/, "");
    protectedText.push(content);
    return `\uE000${protectedText.length - 1}\uE001${match.slice(content.length)}`;
  });
  if (preserveCapitalization) {
    text = text.replace(/[\p{L}\p{M}\p{N}]+(?:['’_-][\p{L}\p{M}\p{N}]+)*/gu, (word) => {
      if (!/[\p{Lu}\p{Lt}]/u.test(word)) return word;
      protectedText.push(word);
      return `\uE000${protectedText.length - 1}\uE001`;
    });
  }
  return text.toLowerCase()
    .replace(/(^|[.!?][\s"'”’)]*\s|\n)[^\p{L}\p{N}\uE000]*\p{L}/gu, (start) => start.toUpperCase())
    .replace(/\bi\b/g, "I")
    .replace(/\uE000(\d+)\uE001/g, (_, index) => protectedText[Number(index)]);
}
